<script lang="ts" setup>
import type { ContentTypeTeam } from '~~/types/storyblok/contentTypes'

const props = defineProps<{
  blok: ContentTypeTeam
  title: string
}>()

// SEO settings
const pageDescription = `${props.title} - ${props.blok.role}` || ''
const pageImage = props.blok.photo.filename || ''

const { applyMeta } = usePageMetaHelper(useRoute())
applyMeta({
  name: `${props.title} - Team`,
  title: props.title,
  description: pageDescription,
  image: pageImage,
})
</script>

<template lang="pug">
article(v-editable="blok" class="content-page")
  header(class="pt-120 md:pt-144 flex flex-col items-center container")
    div(class="max-w-prose-wide px-18 md:px-0")
      TeamMemberDetails(
        :blok="blok"
        :title="title"
      )
</template>
